import { create } from "zustand";

interface DrawerState {
  open: string | null;
  setOpen: (drawerName: string | null) => void;
}

export const useDrawerStore = create<DrawerState>((set) => ({
  open: null,
  setOpen: (drawerName) => set({ open: drawerName }),
}));
